import React from "react";
import Reveal from "./Reveal";

/**
 * Conservative, defensible numbers from the brief — sized at "company" scale.
 * Sits directly under the hero to establish gravitas before the narrative starts.
 */
const STATS = [
  { value: "1,000+", label: "Practitioners certified", note: "Across India, GCC, and SEA" },
  { value: "11", label: "Launch certifications", note: "3 tiers · 6 pillars · 4 channels" },
  { value: "70", label: "Pods built real AI products", note: "Inaugural Innovation Arena" },
  { value: "15", label: "Builders being backed", note: "Capital + mentorship + GTM" },
  { value: "4.9", label: "Average learner rating", note: "Out of 5" },
  { value: "48 hrs", label: "Custom proposal turnaround", note: "For every enquiry" },
];

export default function StatStrip() {
  return (
    <section
      className="relative border-t border-b hairline-strong"
      style={{ background: "var(--canvas)" }}
      data-testid="stat-strip"
    >
      <div className="container-edge py-10 md:py-14">
        <Reveal>
          <p className="mono-label-gold mb-8">BY THE NUMBERS · MAY 2026</p>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-y-10 gap-x-6 lg:gap-x-4">
          {STATS.map((s, i) => (
            <Reveal key={s.label} delay={i * 60}>
              <div data-testid={`stat-${i + 1}`}>
                <p
                  className="font-display tracking-tight leading-none"
                  style={{
                    fontWeight: 400,
                    fontSize: "clamp(36px, 4.6vw, 64px)",
                    color: "var(--ink)",
                  }}
                >
                  {s.value}
                </p>
                <p
                  className="mt-2 text-[13px] font-medium"
                  style={{ color: "var(--ink)" }}
                >
                  {s.label}
                </p>
                <p
                  className="mt-1 font-mono text-[11px]"
                  style={{ color: "var(--ink-tertiary)", letterSpacing: "0.08em" }}
                >
                  {s.note}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
